import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyPageModule } from '@vendasta/galaxy/page';

@Component({
  imports: [GalaxyPageModule, GalaxyEmptyStateModule, MatIconModule, TranslateModule],
  templateUrl: 'page-not-found.component.html',
})
export class PageNotFoundComponent {
  constructor(private router: Router) {
    // Notifications does not support auxilliary routes (or secondary routes) and URL encodes them.
    // This will decode the encoded URL. This is temporary as solution should be done in notificaitons.
    const url = this.router.url.replace(/%28(.*?)%29/g, '($1)');
    if (url !== this.router.url) {
      this.router.navigateByUrl(url);
    }
  }
}
